import React from 'react';

const EyeLashes = ({ imageName, isCustomeMakeup }) => {
  const imgSrc = isCustomeMakeup
    ? require(`../../../assets/imgs/eyelashes_image/${imageName}.jpg`)
    : require(`../../../assets/imgs/new/${imageName}.png`);

  return (
    <img
      className={`shades--img ${isCustomeMakeup ? 'cstm-eyelash-img' : ''}`}
      src={imgSrc}
      alt=""
    />
  );
};

export default EyeLashes;
